import Sidebar from 'components/global/sidebar'
import Navbar from 'components/user/navbar'
import AdContent from 'components/user/newCompaign/AdContent'
import AdditionalTargeting from 'components/user/newCompaign/AdditionalTargeting'
import AdSchedule from 'components/user/newCompaign/AdSchedule'
import CompaignDetails from 'components/user/newCompaign/CompaignDetails'
import GeoLocation from 'components/user/newCompaign/GeoLocation'
import Header from 'components/user/newCompaign/Header'
import KpiReport from 'components/user/newCompaign/KpiReport'
import Steper from 'components/user/newCompaign/Steper'
import Tabs from 'components/user/newCompaign/Tabs'
import React from 'react'
import { useSelector } from 'react-redux'

const NewCompaign = () => {
    const { selectedTab } = useSelector(state => state.newCompaign)

    return (
        <div className="w-full pb-20 md:px-0 px-4 pt-24  ">
            <Navbar />
            <div>
                <Sidebar />
            </div>
            <div className="w-full pl md:pr-20 ">
                <Header />
                <div>
                    <Tabs />
                    <Steper />
                    <div className='light-shadow rounded-md'>
                        {
                            selectedTab?.id === 1 
                            ? 
                                <CompaignDetails />
                            : 
                            selectedTab?.id === 2 
                            ?
                                <GeoLocation />
                            : 
                            selectedTab?.id === 3 
                            ?
                                <AdditionalTargeting />
                            :
                            selectedTab?.id === 4 
                            ?
                                <AdSchedule />
                            : 
                            selectedTab?.id === 5 
                            ?
                                <AdContent />
                            : 
                            selectedTab?.id === 6 
                            ?
                                <KpiReport />
                            : 
                                ''
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NewCompaign